import React from 'react';
import {route, mount, compose, redirect} from 'navi';
import { Helmet } from 'react-navi-helmet-async';
import List from '@2023-mom-web/components/src/list';
import Card from '@2023-mom-web/components/src/card';
import Navigation from '@2023-mom-web/components/src/navigation';
import Entry from '@2023-mom-web/components/src/types/entry';
import { Link } from 'react-navi';
import { list } from '../../json/entry.json';
import { ReactComponent as Logo } from '../../assets/logo.svg';
import loadingImage from '../../assets/loading.png';

export default compose(
  mount({
    '/': redirect("/entries/final"),
    '/all': route({
      getView: ({ context }) => (
        <>
          <Helmet>
            <meta content={`${process.env.REACT_APP_URL}`} property="og:url" />
            <meta content={`${process.env.REACT_APP_OGP_URL}`} property="og:image" />
          </Helmet>
          <App stage={1} />
        </>
      ),
      title: process.env.REACT_APP_WEBSITE_NAME,
    }),
    '/second': route({
      getView: ({ context }) => (
        <>
          <Helmet>
            <meta content={`${process.env.REACT_APP_URL}`} property="og:url" />
            <meta content={`${process.env.REACT_APP_OGP_URL}`} property="og:image" />
          </Helmet>
          <App stage={2} />
        </>
      ),
      title: process.env.REACT_APP_WEBSITE_NAME,
    }),
    '/semifinal': route({
      getView: ({ context }) => (
        <>
          <Helmet>
            <meta content={`${process.env.REACT_APP_URL}`} property="og:url" />
            <meta content={`${process.env.REACT_APP_OGP_URL}`} property="og:image" />
          </Helmet>
          <App stage={3} />
        </>
      ),
      title: process.env.REACT_APP_WEBSITE_NAME,
    }),
    '/final': route({
      getView: ({ context }) => (
        <>
          <Helmet>
            <meta content={`${process.env.REACT_APP_URL}`} property="og:url" />
            <meta content={`${process.env.REACT_APP_OGP_URL}`} property="og:image" />
          </Helmet>
          <App stage={4} />
        </>
      ),
      title: process.env.REACT_APP_WEBSITE_NAME,
    }),
  }),
);

const App = ({ stage }: { stage: number }) => {
  const title = getTitle(stage);
  const subtitle = getSubtitle(stage);
  return (
    <div id="entries">
      <nav className="navbar is-black" role="navigation" aria-label="main navigation">
        <div className="navbar-brand">
          <Link className="navbar-item" href="/">
            <Logo />
          </Link>
        </div>
      </nav>
      <Navigation
        isFinal
        additional={
          <li>
            <a href="https://missofmiss.jp/" target="_blank">
              <span className="icon is-small">
                <i className="fas fa-external-link-alt" aria-hidden="true" />
              </span>
              <span>MISS OF MISS</span>
            </a>
          </li>
        }
      />
      {/* Entries */}
      <section id="entries" className="section">
        <div className="container">
          <div className="mb-6">
            <h1 className="title as-section-title">{title}</h1>
            <h2 className="subtitle">{subtitle}</h2>
          </div>
          <div className="columns is-multiline is-mobile mb-6">
            <List list={list} stage={stage}>
              {(list: Entry[]) =>
                list.map((item: Entry) => (
                  <div className="column is-3-desktop is-4-tablet is-6-mobile" key={item.id}>
                    <Card className="is-mrofmr" loadingImage={loadingImage} href={`/profiles/${item.id}`} entry={item} />
                  </div>
                ))
              }
            </List>
          </div>
        </div>
      </section>
      <footer className="footer has-background-black is-padding-bottom-3">
        <div className="content has-text-centered">
          <Logo width={150} />
          <p className="is-size-7 mt-3">Copyright © 2022 株式会社エイジ・エンタテインメント All Rights Reserved.</p>
        </div>
        <a className="button is-size-7 is-light is-dark" href="mailto:inquiry@missofmiss.jp">
          <span className="icon">
            <i className="far fa-envelope" />
          </span>
          <span>お問い合わせ</span>
        </a>
      </footer>
    </div>
  );
  function getTitle(stage: number) {
      switch (stage) {
          case 4:
              return "FINALIST"
          default:
              return "Entries"
      }
  }
  function getSubtitle(stage: number) {
      switch (stage) {
          case 2:
              return "二次審査進出者一覧"
          case 3:
              return "最終審査進出者一覧"
          case 4:
              return "ファイナリスト一覧"
          default:
              return "出場者一覧"
      }
  }
};
